if (!customElements.get('zoyo-cart-recommendations')) {
  customElements.define(
    'zoyo-cart-recommendations',
    class ZoyoCartRecommendations extends HTMLElement {
      connectedCallback() {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.queueRefresh());
      }

      disconnectedCallback() {
        this.unsubscribe?.();
        clearTimeout(this.refreshTimer);
        this.controller?.abort();
      }

      queueRefresh() {
        clearTimeout(this.refreshTimer);
        this.controller?.abort();
        this.hidden = true;
        this.refreshTimer = setTimeout(() => this.refresh(), 180);
      }

      async refresh() {
        const controller = new AbortController();
        this.controller = controller;
        const timeout = setTimeout(() => controller.abort(), 8000);

        try {
          const url = new URL(this.dataset.cartUrl, window.location.origin);
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url.toString(), {
            method: 'GET',
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { Accept: 'text/html' },
            signal: controller.signal,
          });
          if (!response.ok) throw new Error('Cart recommendations unavailable');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const section = html.querySelector('zoyo-cart-recommendations');
          if (!section || controller.signal.aborted || !this.isConnected) return;
          this.innerHTML = section.innerHTML;
          this.hidden = section.hidden;
        } catch {
          if (this.controller === controller) this.hidden = true;
        } finally {
          clearTimeout(timeout);
        }
      }
    }
  );
}
